import { render, staticRenderFns } from "./partnerMovementsTable.vue?vue&type=template&id=760631c0&"
import script from "./partnerMovementsTable.vue?vue&type=script&lang=ts&"
export * from "./partnerMovementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports